module.exports = __webpack_public_path__ + "static/media/DualBrunchMenu.a5c8e1b0.pdf";